export default __webpack_public_path__ + "static/reishishover-e6139a6c434a0ceeda9ffdf4f67b819a.png";